import { ReactNode } from "react";

interface PopUpProps {
    title: string;
    text?: string;
    element?: ReactNode;
    onClick: () => void;
}

export function PopUp(props: PopUpProps) {
    return (
        <div className="popup-overlay">
            <div className="popup">
                <h2>{props.title}</h2>
                <button className="popup-close" onClick={props.onClick}>&times;</button>
                <div className="popup-content">
                    {props.element ? props.element : <p>{props.text}</p>}
                </div>
            </div>
        </div>
    );
}

export default PopUp;
